import {
  cache_clear,
  cache_read,
  cache_write,
  grid_barColorsName,
} from "src/components/js/CacheFunctions";
import { checkResponse } from "src/components/js/statics1";
import keikkaEval from "src/data/keikkaLasku/keikkaEval";

// barColorsClass
// - barColors: array of barColorClass
export default class barColorsClass {
  constructor() {
    this.barColors = [];
  }

  processCResponse(cResponse) {
    if (cResponse.data?.length === 0) return;
    this.barColors = [];
    for (let i = 0; i < cResponse.data.length; i++) {
      const _barColor = new barColorClass();
      _barColor.barColorId = cResponse.data[i].barColorId;
      _barColor.ehto = cResponse.data[i].ehto;
      _barColor.style = cResponse.data[i].style;
      _barColor.comment = cResponse.data[i].comment;
      _barColor.sortNo = cResponse.data[i].sortNo;
      _barColor.ownerAsiakasId = cResponse.data[i].ownerAsiakasId;
      _barColor.isActive = cResponse.data[i].isActive || true;
      _barColor.iconName = cResponse.data[i].iconName || null;
      _barColor.iconColor = cResponse.data[i].iconColor || "#000000";
      _barColor.iconBackgroundColor = cResponse.data[i].iconBackgroundColor || "#CCCCCC";
      this.barColors.push(_barColor);
    }
    // sort barColors by sortNo
    this.barColors.sort((a, b) => a.sortNo - b.sortNo);
    return this;
  }

  async init(token, ownerAsiakasId = 0) {
    const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/grid/barColors/list/" + ownerAsiakasId;
    const c = cache_read(grid_barColorsName, fullUrl);
    if (c) {
      this.processCResponse(c);
      return;
    }

    const requestOptions = {
      method: "GET",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
        "Cache-Control": 10,
      },
    };
    const response = await fetch(fullUrl, requestOptions);
    const cResponse = await checkResponse(response, "barColorsClass.init");
    if (cResponse.success) {
      cache_write(grid_barColorsName, fullUrl, cResponse, 0);
      this.processCResponse(cResponse);
    }
  }

  // get styles for keikkaData based on barColors rules and keikkaData values
  // return array of styles for keikkaData
  getStyles(keikkaData) {
    const results = [];
    for (let i = 0; i < this.barColors.length; i++) {
      const barColor = this.barColors[i];
      const evalResult = keikkaEval(barColor.ehto, keikkaData);
      if (evalResult) results.push(barColor);
    }
  }
}

// barColorClass
// - barColorId: int
// - ehto: string
// - style: string
// - comment: string
// saveToDb(token): bool
// - token: string
export class barColorClass {
  constructor() {
    this.barColorId = 0;
    this.ehto = "";
    this.style = "";
    this.comment = "";
    this.sortNo = 0;
    this.ownerAsiakasId = 0;
    this.isActive = true;
    this.iconName = null;
    this.iconColor = "#000000";
    this.iconBackgroundColor = "#CCCCCC";
  }
  async delete(token) {
    cache_clear(grid_barColorsName);
    const fullUrl =
      import.meta.env.VITE_SERVER_URL + "/api/grid/barColors/delete/" + this.barColorId;
    const requestOptions = {
      method: "DELETE",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
        "Cache-Control": 10,
      },
    };
    const response = await fetch(fullUrl, requestOptions);
    const cResponse = await checkResponse(response, "barColorClass.delete");
    return cResponse.success;
  }

  static async saveToDb(barColor, token) {
    cache_clear(grid_barColorsName);
    const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/grid/barColors/save";
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
        "Cache-Control": 10,
      },
      body: JSON.stringify({
        barColorId: barColor.barColorId,
        ehto: barColor.ehto,
        style: barColor.style,
        comment: barColor.comment,
        sortNo: barColor.sortNo,
        ownerAsiakasId: barColor.ownerAsiakasId,
        isActive: barColor.isActive,
        iconName: barColor.iconName,
        iconColor: barColor.iconColor,
        iconBackgroundColor: barColor.iconBackgroundColor,
      }),
    };
    const response = await fetch(fullUrl, requestOptions);
    return response.ok;
  }
}
